import { useCallback } from 'preact/hooks';
import { api } from '../lib/api.js';
import { useFetch } from '../lib/useFetch.js';
import type { Flags as FlagsResponse } from '../lib/types.js';

export function Flags() {
  const fetchFlags = useCallback(() => api.get<FlagsResponse>('/api/admin/flags'), []);
  const flags = useFetch(fetchFlags, []);

  return (
    <div>
      <h1 class="page-title">Flags</h1>
      {flags.error && <div class="error-banner">{flags.error}</div>}
      <div class="card" style={{ maxWidth: 420 }}>
        <div class="row" style={{ justifyContent: 'space-between' }}>
          <div>
            <b>Monetization enabled</b>
            <div class="hint">
              Read-only until M5 — owner + founder always get full entitlements free.
            </div>
          </div>
          <span class="chip" data-status={flags.data?.monetizationEnabled ? 'done' : 'declined'}>
            {flags.loading ? '…' : flags.data?.monetizationEnabled ? 'On' : 'Off'}
          </span>
        </div>
      </div>
    </div>
  );
}
